import { motion } from 'motion/react';

export const StepHeader = ({ title, isActive }: { title: string; isActive: boolean }) => {
  return (
    <motion.div
      className={`flex items-center mb-4 ${isActive ? 'opacity-100' : 'opacity-60'}`}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: isActive ? 1 : 0.6, y: 0 }}
      transition={{ delay: 0.1, duration: 0.4 }}
    >
      <h2 className="text-content-on-dark-default text-md font-semibold">{title}</h2>
    </motion.div>
  );
};
